// extracted by mini-css-extract-plugin
export default {"searchForm":"styles_searchForm__HjNgL","searchInput":"styles_searchInput__eM-Tt","iconSearch":"styles_iconSearch__AV+Cr","iconSearchClose":"styles_iconSearchClose__xxdID"};